import React from 'react';
import { cn } from '../../shared/util/cn';

export const List = React.forwardRef<HTMLUListElement, React.HTMLAttributes<HTMLUListElement>>(
  ({ className, ...props }, ref) => (
    <ul
      ref={ref}
      className={cn('divide-y divide-[var(--color-mockup-border)]', className)}
      {...props}
    />
  )
);
List.displayName = 'List';

export const ListItem = React.forwardRef<HTMLLIElement, React.HTMLAttributes<HTMLLIElement>>(
  ({ className, ...props }, ref) => (
    <li
      ref={ref}
      className={cn('px-4 py-2', className)}
      {...props}
    />
  )
);
ListItem.displayName = 'ListItem';

export interface ListItemTextProps extends React.HTMLAttributes<HTMLDivElement> {
  primary?: React.ReactNode;
  secondary?: React.ReactNode;
}

export const ListItemText = React.forwardRef<HTMLDivElement, ListItemTextProps>(
  ({ className, primary, secondary, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex flex-col', className)}
      {...props}
    >
      {primary && (
        <span className="text-sm font-semibold text-[var(--color-mockup-text)]">
          {primary}
        </span>
      )}
      {secondary && (
        <span className="text-sm text-[var(--color-mockup-text-mid)]">
          {secondary}
        </span>
      )}
    </div>
  )
);
ListItemText.displayName = 'ListItemText';

export const ListItemIcon = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('mr-3 shrink-0', className)}
      {...props}
    />
  )
);
ListItemIcon.displayName = 'ListItemIcon';

export const ListItemSecondaryAction = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('ml-auto shrink-0', className)}
      {...props}
    />
  )
);
ListItemSecondaryAction.displayName = 'ListItemSecondaryAction';
